export default __webpack_public_path__ + "static/media/logo1.a576e407.png";